/**
 * @generated SignedSource<<0a1f719ba13958e9600c0d16dcebb2d3>>
 * @relayHash d79f2b2b8d350a6f7f19e68cd4a61664
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b12fec34a71db670f12e121e2b6009b6b60a30f3e798ff77a4c57cc87d9b898d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiExperimentCoordinatorEndOfTrialExtensionQuery } from './uiExperimentCoordinatorEndOfTrialExtensionQuery.graphql';

const node: PreloadableConcreteRequest<uiExperimentCoordinatorEndOfTrialExtensionQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b12fec34a71db670f12e121e2b6009b6b60a30f3e798ff77a4c57cc87d9b898d",
    "metadata": {},
    "name": "uiExperimentCoordinatorEndOfTrialExtensionQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
